
export default function Problem() {
  const problems = [
    {
      title: 'Missed Calls',
      description: 'Inbound inquiries go unanswered. Opportunities disappear.',
      icon: 'ri-phone-line',
      image: 'https://public.readdy.ai/ai/img_res/77e363706b6f4d68b1143c2750f34d5a.jpg'
    },
    {
      title: 'Slow Follow-Up',
      description: 'Response delays reduce close rates across every industry.',
      icon: 'ri-time-line',
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20hourglass%20with%20sand%20falling%20on%20a%20dark%20navy%20surface%20representing%20time%20running%20out%20soft%20dramatic%20lighting%20clean%20modern%20premium%20aesthetic%20shallow%20depth%20of%20field%20cinematic%20moody%20atmosphere%20professional%20business%20concept%20dark%20tones&width=600&height=400&seq=problem-card-2&orientation=landscape'
    },
    {
      title: 'Manual Intake',
      description: 'Staff overload creates bottlenecks and inconsistent qualification.',
      icon: 'ri-user-line',
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20overhead%20view%20of%20cluttered%20paperwork%20and%20sticky%20notes%20on%20a%20dark%20navy%20desk%20representing%20manual%20overload%20soft%20ambient%20lighting%20clean%20modern%20premium%20aesthetic%20shallow%20depth%20of%20field%20cinematic%20moody%20atmosphere%20professional%20business%20setting&width=600&height=400&seq=problem-card-3&orientation=landscape'
    }
  ];

  return (
    <section className="bg-white py-28 lg:py-36">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#2563EB] mb-4">The Problem</p>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-[#0B1C2D] tracking-tight">
            Where Revenue Slips Through
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="group rounded-2xl overflow-hidden bg-[#F8FAFC] hover:shadow-xl transition-all duration-500 cursor-pointer"
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={problem.image}
                  alt={problem.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-8">
                <div className="w-10 h-10 flex items-center justify-center mb-5 bg-[#2563EB]/10 rounded-xl">
                  <i className={`${problem.icon} text-xl text-[#2563EB]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#0B1C2D] mb-3">
                  {problem.title}
                </h3>
                <p className="text-base text-gray-500 leading-relaxed">
                  {problem.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
